import { isNullOrWhiteSpace } from "./utils";

import { XNSError } from "../errors/XNSError";

const DEV_WEB_SERVER = 'http://' + window.location.hostname + ':8083/';
let SERVER_URL = '/';

/* eslint-disable no-undef */
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_LOCAL_DEV === 'true') {
    /* eslint-enable no-undef */
    SERVER_URL = DEV_WEB_SERVER;
}

export class Api {
    static async getVersion() {
        let response = await fetch(SERVER_URL + 'api/system/version');
        let json = await response.json();

        return json.version;
    }
    static async getSystem() {
        let response = await fetch(SERVER_URL + 'api/system', {
            method: 'GET'
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async updateSystem(systemTime, isCableAssembly) {
        let response = await fetch(SERVER_URL + 'api/system', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ systemTime, isCableAssembly })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async getDatabaseBackupSettings() {
        let response = await fetch(SERVER_URL + 'api/system/backup', {method: 'GET'});
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }
    static async updateDatabaseBackupSettings(path, frequency, time, day, number) {
        let response = await fetch(SERVER_URL + 'api/system/backup', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({path, frequency, time, day, number})
        })
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async getIp() {
        let response = await fetch(SERVER_URL + 'api/system/ip');
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.ip;
    }
    static async getSize() {
        let response = await fetch(SERVER_URL + 'api/system/size');
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.size;
    }

    static async getSystemLogs(level) {
        let response = await fetch(SERVER_URL + 'api/logs/system?level=' + level);
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async getDeviceTypes() {
        let response = await fetch(SERVER_URL + 'api/device-types');
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json;
    }
    static async getUsers() {
        let response = await fetch(SERVER_URL + 'api/auth');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async createUser(username, password, admin) {
        let response = await fetch(SERVER_URL + 'api/auth', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, password, admin })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async updateUser(username, newPassword) {
        let response = await fetch(SERVER_URL + 'api/auth', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, newPassword })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async login(info) {
        let response = await fetch(SERVER_URL + 'api/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        });

        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }
    static async getCount() {
        let response = await fetch(SERVER_URL + 'api/auth/count', {
            method: 'GET'
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async deleteUser(username) {
        let response = await fetch(SERVER_URL + 'api/auth/' + username, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username })
        });
        
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Devices

    static async getDevices() {
        let response = await fetch(SERVER_URL + 'api/devices');
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async updateDevice(deviceId, data) {
        let response = await fetch(SERVER_URL + 'api/devices/' + deviceId, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async deleteDevice(deviceId) {
        let request = await fetch(SERVER_URL + 'api/devices/' + deviceId, {
            method: 'DELETE'
        });
        let json = await request.json();
        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }

        return json;
    }

    // Stations

    static async getStations() {
        let response = await fetch(SERVER_URL + 'api/stations');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async createStation(name) {
        let response = await fetch(SERVER_URL + 'api/stations', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name })
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async updateStation(stationId, data) {
        let response = await fetch(SERVER_URL + 'api/stations/' + stationId, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async deleteStation(stationId) {
        let response = await fetch(SERVER_URL + 'api/stations/' + stationId, {
            method: 'DELETE'
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async pushTestPlan(data) {
        let response = await fetch(SERVER_URL + 'api/stations/push', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    // Peripherals

    static async getPeripherals() {
        let request = await fetch(SERVER_URL + 'api/peripherals');
        let json = await request.json();

        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }
        return json.message;
    }

    static async createPeripheral(deviceTypeId, name) {
        let request = await fetch(SERVER_URL + 'api/peripherals', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ deviceTypeId, name, address: name })
        });
        let json = await request.json();
        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }
        return json.message;
    }

    static async deletePeripheral(id) {
        let request = await fetch(SERVER_URL + 'api/peripherals/' + id, {
            method: 'DELETE'
        });

        return request;
    }

    static async assignPeripheral(peripheralId, stationId) {
        let request = await fetch(SERVER_URL + 'api/peripherals/assign/' + peripheralId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ stationId })
        });
        let json = await request.json();
        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }
        return json;
    }

    static async unassignPeripheral(peripheralId, stationId) {
        let request = await fetch(SERVER_URL + 'api/peripherals/unassign/' + peripheralId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ stationId })
        });
        let json = await request.json();
        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }
        return json;
    }

    static async getTestPlans() {
        let testplans = await fetch(SERVER_URL + 'api/test-plans').then(handleResponse);
        return testplans;
    }

    static async getTestPlan(id) {
        let request = await fetch(SERVER_URL + 'api/test-plans?id=' + id).then(handleResponse);

        return request[0];
    }

    static async getTestPlanByName(name) {
        let request = await fetch(SERVER_URL + 'api/test-plans/test-name?name=' + name).then(handleResponse);

        return request;
    }

    static async createTestPlan(testPlan) {
        testPlan = { ...testPlan };

        let request = await fetch(SERVER_URL + 'api/test-plans', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(testPlan)
        });
        let json = await request.json();

        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }

        return request;
    }

    static async updateTestPlan(uuid, testPlan) {
        let request = await fetch(SERVER_URL + 'api/test-plans/' + uuid, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(testPlan)
        });

        let json = await request.json();

        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }

        return request;
    }

    static async deleteTestPlan(id) {
        let request = await fetch(SERVER_URL + 'api/test-plans/' + id, {
            method: 'DELETE'
        });
        if (request.status !== 200) {
            let json = await request.json();
            throw new XNSError({ message: json.error, status: request.status });
        }

        return request;
    }

    static async cloneTestPlan(testPlan) {
        let request = await fetch(SERVER_URL + 'api/test-plans/clone', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(testPlan)
        });
        
        let json = await request.json();

        if (request.status !== 200) {
            console.debug(json);
            throw new XNSError({ message: json.error, status: request.status });
        }

        return json.message;
    }

    static async importTestPlan(testPlan) {
        let request = await fetch(SERVER_URL + 'api/test-plans/import', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ hashedTestPlan: testPlan })
        });
        
        let json = await request.json();
        if (request.status !== 200) {
            console.debug(json);
            throw new XNSError({ message: json.error, status: request.status });
        }

        return json.message;
    }

    static async exportBarcode(barcode) {
        let request = await fetch(SERVER_URL + 'api/test-plans/export-barcode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(barcode)
        });
        let json = await request.json();
        if (request.status !== 200) {
            throw new XNSError({ message: json.error, status: request.status });
        }

        return json.message;
    }

    // Test Blocks

    static async createTestBlock(testBlock) {
        let response = await fetch(SERVER_URL + 'api/test-blocks', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(testBlock)
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Custom Fields

    static async getCustomFields() {
        let customFields = await fetch(SERVER_URL + 'api/custom-fields').then(handleResponse);

        return customFields;
    }

    static async getCustomField(id) {
        let customFields = await fetch(SERVER_URL + 'api/custom-fields?id=' + id).then(handleResponse);

        return customFields[0];
    }

    static async createCustomField(customField) {
        let response = await fetch(SERVER_URL + 'api/custom-fields', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: customField
            })
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async deleteCustomField(id) {
        let response = await fetch(SERVER_URL + 'api/custom-fields/' + id, {
            method: 'DELETE'
        });
        if (response.status !== 200) {
            let json = await response.json();
            throw new XNSError({ message: json.error, status: response.status });
        }

        return response;
    }

    static async importCustomFields(content) {
        let response = await fetch(SERVER_URL + 'api/custom-fields/import', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(content)
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // labels

    static async getLabels() {
        let response = await fetch(SERVER_URL + 'api/labels');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async getExcelLabels() {
        let response = await fetch(SERVER_URL + 'api/labels/excel');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
    static async deleteExcelLabel(name) {
        let request = await fetch(SERVER_URL + 'api/labels/remove/' + name, {
            method: 'DELETE'
        });
        if (request.status !== 200) {
            let json = await request.json();
            throw new XNSError({ message: json.error, status: request.status });
        }
        return request;
    }

    static async getLabelPdf(id) {
        let response = await fetch(SERVER_URL + 'api/labels/pdf?id=' + id);
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async createLabel(label) {
        let response = await fetch(SERVER_URL + 'api/labels', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(label)
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json;
    }
    static async getLabel(id) {
        let response = await fetch(SERVER_URL + 'api/labels?id=' + id);
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message[0];
    }
    static getLabelDownloadUrl(data: { excelFile: string }) {
        const params = new URLSearchParams();

        params.append('excelFile', data.excelFile);

        return SERVER_URL + 'api/labels/xlsx?' + params.toString();
    }

    static async updateLabel(id, label) {
        let response = await fetch(SERVER_URL + 'api/labels/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(label)
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async deleteLabel(id) {
        let response = await fetch(SERVER_URL + 'api/labels/' + id, {
            method: 'DELETE'
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // mDNS

    static async mdnsScan() {
        let response = await fetch(SERVER_URL + 'api/mdns/scan');

        return response;
    }

    static async mdnsGetDevices() {
        let response = await fetch(SERVER_URL + 'api/mdns');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async assignServer(deviceIpAddress, devicePortNumber) {
        let response = await fetch(SERVER_URL + 'api/mdns/assign-server', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ipAddress: deviceIpAddress,
                port: devicePortNumber
            })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Results

    static async getResult(resultId) {
        let response = await fetch(SERVER_URL + 'api/results?id=' + resultId);
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Printers

    static async getPrinters() {
        let response = await fetch(SERVER_URL + 'api/printing');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Polarities

    static async getPolarities() {
        let response = await fetch(SERVER_URL + 'api/custom-polarities');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async getPolaritiesByFiberCount(fiberCount, options) {
        let response = await fetch(SERVER_URL + 'api/custom-polarities?' + new URLSearchParams({ fibers: fiberCount, ...options }));
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async createPolarity(name, fibers, polarity) {
        let response = await fetch(SERVER_URL + 'api/custom-polarities', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, fibers, polarity })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async updatePolarity(id, data) {
        let response = await fetch(SERVER_URL + 'api/custom-polarities/' + id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        let json = await response.json();
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json;
    }

    static async deletePolarity(record) {
        let response = await fetch(SERVER_URL + 'api/custom-polarities/' + record, {
            method: 'DELETE'
        });
        
        const status = response.status;
        const json = await response.json();

        if (status !== 200) {
            switch(status) {
                case 404:
                    throw new XNSError({message: `Polarity ${record.name} not found`, status});
                case 409:
                    throw new XNSError({
                        title: 'Unabled to delete Polarity - In use',
                        message: `Polarity '${record.name}' must be removed from the following Test Plans before deletion: \n${json.testPlans.map(plan => plan.name).join(',\n')}`, 
                        status
                    });
                default:
                    throw new XNSError({ message: json.error, status});
            }
        }

        return { status, json };
    }

    static async importPolarity(payload) {
        let response = await fetch(SERVER_URL + 'api/custom-polarities/import', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        
        let json = await response.json();
        
        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Connectors

    static async createConnector(connector) {
        let response = await fetch(SERVER_URL + 'api/custom-connectors', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(connector)
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async getConnectors() {
        let response = await fetch(SERVER_URL + 'api/custom-connectors');
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async getConnectorsByFiberCount(fiberCount) {
        let response = await fetch(SERVER_URL + 'api/custom-connectors?fiberCount=' + fiberCount);
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async updateConnector(id, connector) {
        let response = await fetch(SERVER_URL + 'api/custom-connectors/' + id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(connector)
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json;
    }

    static async deleteConnector(id) {
        let response = await fetch(SERVER_URL + 'api/custom-connectors/' + id, {
            method: 'DELETE'
        });
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async importConnectors(payload) {
        let response = await fetch(SERVER_URL + 'api/custom-connectors/import', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Data Browser

    static async getDataBrowser(data) {
        const params = new URLSearchParams();

        if ('resultsPerPage' in data) {
            params.append('resultsPerPage', data.resultsPerPage);
        }

        if ('page' in data) {
            params.append('page', data.page);
        }

        if ('filterParams' in data) {
            params.append('filterParams', JSON.stringify(data.filterParams));
        } else {
            params.append('filterParams', '{}');
        }

        if(data.sort && !isNullOrWhiteSpace(data.sort)) {
            params.append('orderParams', data.sort);
        }

        let response = await fetch(SERVER_URL + 'api/data-browser?' + params.toString());
        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async getCsvDownloadUrl(data) {
        const params = new URLSearchParams();

        if ('excel' in data && data.excel) {
            params.append('excel', '1');
        }

        if ('detailed' in data && data.detailed) {
            params.append('detailed', '1');
        }

        if ('filterParams' in data) {
            params.append('filterParams', JSON.stringify(data.filterParams));
        } else {
            params.append('filterParams', '{}');
        }
        params.append('fileName', data.fileName);

        return SERVER_URL + 'api/data-browser/csv?' + params.toString();
    }

    /**
     * Downloads CSV data from the data browser.
     *
     * @param {Object} data - Request configuration
     * @param {Object} data.filterParams - Filter parameters for the query
     * @param {boolean} [data.excel] - If true, format for Excel compatibility
     * @param {boolean} [data.detailed] - If true, include detailed fiber measurements
     * @param {string} [data.fileName] - Desired filename for the download (sanitized on server)
     * @returns {Promise<Blob>} CSV data as a Blob ready for download
     * @throws {XNSError} If the HTTP request fails
     */
    static async getDataBrowserCsv(data) {
        const url = await this.getCsvDownloadUrl(data);
        const response = await fetch(url);

        if (!response.ok) {
            throw new XNSError({ message:`HTTP error! status: ${response.status}`, status: response.status });
        }

        return response.blob();
    }

    static async getXlsxDownloadUrl(data) {
        const params = new URLSearchParams();

        if ('excel' in data && data.excel) {
            params.append('excel', '1');
        }

        if ('detailed' in data && data.detailed) {
            params.append('detailed', '1');
        }

        if ('filterParams' in data) {
            params.append('filterParams', JSON.stringify(data.filterParams));
        } else {
            params.append('filterParams', '{}');
        }
        params.append('fileName', data.fileName);

        return SERVER_URL + 'api/data-browser/xlsx?' + params.toString();
    }

    static async getLabelPdfData(labelId, dutId, testBlockId, cableCoreSize, testPlanId) {
        let response = await fetch(
            SERVER_URL +
                'api/labels/pdf-data?labelId=' +
                labelId +
                '&dutId=' +
                dutId +
                '&testBlockId=' +
                testBlockId +
                '&cableCoreSize=' +
                cableCoreSize +
                '&testPlanId=' +
                testPlanId
        );

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    // Legacy Migration
    static async startMigration(mssqlConfig) {
        let response = await fetch(SERVER_URL + 'api/mssql-migration', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mssqlConfig)
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async validateMigration(mssqlConfig) {
        let response = await fetch(SERVER_URL + 'api/mssql-migration/validate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mssqlConfig)
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async cancelMigration() {
        let response = await fetch(SERVER_URL + 'api/mssql-migration/cancel', {
            method: 'POST'
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }
        return json.message;
    }

    static async getStatusMigration() {
        let response = await fetch(SERVER_URL + 'api/mssql-migration/status', {
            method: 'GET'
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async importTconnectors(mssqlConfig) {
        let response = await fetch(SERVER_URL + 'api/mssql-migration/connectors', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mssqlConfig)
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async createSubscriber(url) {
        let response = await fetch(SERVER_URL + 'api/subscribers/create-subscriber', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                url: url
            })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }

    static async getSubscribers() {
        let subscribers = await fetch(SERVER_URL + 'api/subscribers').then(handleResponse);
        return subscribers;
    }
    static async deleteSubscriber(id) {
        let response = await fetch(SERVER_URL + 'api/subscribers/delete-subscriber/' + id, {
            method: 'DELETE'
        });

        if (response.status !== 200) {
            let json = await response.json();
            throw new XNSError({ message: json.error, status: response.status });
        }

        return response;
    }
    static async updateSubscriber(id, url) {
        let response = await fetch(SERVER_URL + 'api/subscribers/update-subscriber', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, url: url })
        });

        let json = await response.json();

        if (response.status !== 200) {
            throw new XNSError({ message: json.error, status: response.status });
        }

        return json.message;
    }
}

async function handleResponse(response) {
    let json = await response.json();

    if (response.status !== 200) {
        throw new XNSError({ message: json.error, status: response.status });
    }

    return json.message;
}
